import { createBrowserRouter } from "react-router";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { AdminRoute } from "@/components/auth/admin-route";
import { DashboardLayout } from "@/components/layout/dashboard-layout";
import ErrorPage from "@/pages/error-page";
import NotFoundPage from "@/pages/not-found-page";
import LandingPage from "@/pages/landing-page";
import LoginPage from "@/pages/login-page";
import InitiativeRequestPage from "@/pages/initiative-request-page";
import DashboardPage from "@/pages/dashboard-page";
import AnalyticsPage from "@/pages/analytics-page";
import InitiativesPage from "@/pages/initiatives-page";
import InitiativeDetailPage from "@/pages/initiative-detail-page";
import ContributionsPage from "@/pages/contributions-page";
import SettingsPage from "@/pages/settings-page";
import ForgotPasswordPage from "@/pages/forgot-password-page";
import VerifyOtpPage from "@/pages/verify-otp-page";
import ResetPasswordPage from "@/pages/reset-password-page";
import SetPasswordPage from "@/pages/set-password-page";
import InviteEnablerPage from "@/pages/invite-enabler-page";
import CompleteProfilePage from "@/pages/complete-profile-page";
import JuthoorAdminPage from "@/pages/juthoor-admin-page";
import JuthoorAdminInitiativeDetailPage from "@/pages/juthoor-admin-initiative-detail-page";

import PrivacyPolicyPage from "@/pages/privacy-policy-page";
import TermsAndConditionsPage from "@/pages/terms-and-conditions-page";

export const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    children: [
      // Public routes
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        // Initiative entity account request — public, no auth required
        path: "/auth/initiative/request",
        element: <InitiativeRequestPage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/verify-otp",
        element: <VerifyOtpPage />,
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "/auth/set-password/:code",
        element: <SetPasswordPage />,
      },
      {
        path: "/invite/:id",
        element: <InviteEnablerPage />,
      },

      // Protected dashboard routes
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: "/dashboard",
            element: <DashboardLayout />,
            children: [
              {
                index: true,
                element: <DashboardPage />,
              },
              {
                path: "analytics",
                element: <AnalyticsPage />,
              },
              {
                path: "initiatives",
                element: <InitiativesPage />,
              },
              {
                path: "initiatives/:id",
                element: <InitiativeDetailPage />,
              },
              {
                path: "contributions",
                element: <ContributionsPage />,
              },
              {
                path: "settings",
                element: <SettingsPage />,
              },
              {
                path: "complete-profile",
                element: <CompleteProfilePage />,
              },
            ],
          },

          // Admin-only routes (role === 'admin')
          {
            element: <AdminRoute />,
            children: [
              {
                path: "/dashboard/admin",
                element: <DashboardLayout />,
                children: [
                  {
                    path: "juthoor",
                    element: <JuthoorAdminPage />,
                  },
                  {
                    path: "juthoor/initiatives/:id",
                    element: <JuthoorAdminInitiativeDetailPage />,
                  },
                ],
              },
            ],
          },
        ],
      },

      // Catch-all 404
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
